import { render } from "./Templates.vue?vue&type=template&id=40771382&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"

import "./Templates.vue?vue&type=style&index=0&id=40771382&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40771382"]])

export default __exports__